module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_f_piebald.555a3e4f.png";